module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow is-hoverable"
  }, [_c('thead', _vm._l((_vm.headings), function(heading) {
    return _c('th', {
      key: heading,
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(heading))])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id,
      on: {
        "click": function($event) {
          return _vm.onClick(row.id)
        }
      }
    }, _vm._l((row), function(data, index) {
      return (index !== 'id') ? _c('td', {
        key: data.id
      }, [_vm._v("\n                " + _vm._s(data) + "\n              ")]) : _vm._e()
    }), 0)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ff5010d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/playerTable.vue
// module id = 616
// module chunks = 30